import { faArrowRight, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Censo = () => {
  return (
    <div className="ppart-container">
      <h2 className="ppart-title">Censo Oliva 2025</h2>
      <p className="ppart-desc">
        El CENSO Oliva 2025 es una herramienta fundamental para conocer en
        profundidad la realidad de nuestra Ciudad y poder planificar mejor su
        futuro. ¡Contamos con vos! Sumate al Censo Oliva 2025.
      </p>
      <div className="ppart-links">
        <div className="ppart-link-block">
          <FontAwesomeIcon icon={faArrowRight} className="ppart-link-icon" />
          <a
            href="https://lookerstudio.google.com/reporting/673f90f2-0a23-45b6-b901-18c24eb1edec"
            target="_blank"
            rel="noopener noreferrer"
            className="ppart-link"
          >
            Resultados Censo Oliva 2025
          </a>
        </div>
        <div className="ppart-link-block">
          <FontAwesomeIcon icon={faFilePdf} className="ppart-link-icon" />
          <a
            href="https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/CENSO.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="ppart-link"
          >
            Descargar PDF Coordinadores Operativos
          </a>
        </div>
      </div>
    </div>
  );
};

export default Censo;
